import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SessionService } from '@core';
import { BaseResult } from '@shared';

import { ConfigurableOfficeInfo } from '../../models/configurable-office-info.model';

@Injectable({
    providedIn: 'root'
})
export class OptimizationConfigurationService {
    private readonly httpClient = inject(HttpClient);
    private readonly sessionService = inject(SessionService);


    public updateOptimizationConfigurations(configuration: ConfigurableOfficeInfo): Observable<BaseResult> {
        const url = `${this.sessionService.getApiUrl()}/update_optimization_configurations_v2/${
            this.sessionService.requestId
        }`;
        const body = JSON.parse(JSON.stringify(configuration));

        return this.httpClient.put<BaseResult>(url, body);
    }
}
